import { NgModule } from '@angular/core';
import { TuiRootModule } from '@taiga-ui/core';
import { TuiInputFilesModule } from '@taiga-ui/kit';

/**
 * Shared Taiga UI modules for newer components.
 * Import this module in feature modules that use Taiga controls.
 */
const TAIGA_MODULES = [TuiRootModule, TuiInputFilesModule];

@NgModule({
  exports: [...TAIGA_MODULES],
})
export class TaigaUiSharedModule {}

export { TuiRootModule };
